import { Button, Card, Typography } from "@mui/material";
import { VerifyEmailRequest } from "api/auth/verifyEmail";
import { useAppDispatch } from "app/hooks";
import { verifyEmail, logOut } from "features/auth/authSlice";
import ConfirmModal from "features/confirmModal/ConfirmModal";
import CenterContainer from "features/containers/CenterContainer";
import { useForm } from "hooks/useForm";
import { useState } from "react";

const PendingApprovalComponent: React.FC = () => {
  const dispatch = useAppDispatch();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // Using form hook for validation
  const {
    handleSubmit,
    handleChange,
    data: verifyData,
    errors,
  } = useForm<VerifyEmailRequest>({
    validations: {
      verificationCode: {
        custom: {
          isValid: (value) => value.length > 0,
          message: "Ange en kod",
        },
      },
    },
    initialValues: {
      verificationCode: "",
    },
    onSubmit: () => {
      dispatch(verifyEmail(verifyData));
    },
  });

  return (
    <CenterContainer>
      <Card
        elevation={8}
        sx={{ display: "grid", placeItems: "center", gap: 2, p: 4, borderRadius: "1rem" }}
      >
        <Typography variant="h1" fontSize="2rem" textAlign="center">
          Väntar på godkännande
        </Typography>

        <Typography className="text-center">
          För att du ska få tillgång till ditt konto måste det först godkännas av en admin.
        </Typography>
        <Typography className="text-center">
          När ditt konto har godkänts kan du prova uppdatera den här sidan.
        </Typography>

        <Button color="error" variant="contained" onClick={() => setShowConfirmModal(true)}>
          Logga ut
        </Button>

        <ConfirmModal
          handleClose={() => {
            setShowConfirmModal(false);
          }}
          handleConfirm={() => {
            dispatch(logOut());
          }}
          show={showConfirmModal}
          title="Logga ut"
          message="Är du säker på att du vill logga ut?"
          confirmLabel="Logga ut mig"
          dismissLabel="Avbryt"
          isLoading={false}
        />
      </Card>
    </CenterContainer>
  );
};

export default PendingApprovalComponent;
